/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_BookingInputs */

const en_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking…`)
};

const es_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservando…`)
};

const de_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchung…`)
};

const zh_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在预订…`)
};

const ar_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ الحجز…`)
};

const fr_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservation…`)
};

const vi_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang đặt…`)
};

const sw_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaweka nafasi…`)
};

const th_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังจอง…`)
};

const bs_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervisanje…`)
};

const ja_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予約中…`)
};

const ko_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예약 중…`)
};

const pt_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservando…`)
};

const it_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenotazione…`)
};

const sv_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bokar…`)
};

const nl_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserveren…`)
};

const da_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booker…`)
};

const nb_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestiller…`)
};

const fi_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varataan…`)
};

const pl_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacja…`)
};

const ru_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бронируем…`)
};

const tr_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervasyon yapılıyor…`)
};

const hi_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बुकिंग…`)
};

const id_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memesan…`)
};

const ms_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menempah…`)
};

const cs_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervace…`)
};

const el_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κράτηση…`)
};

const he_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מזמינים…`)
};

const af_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespreek tans…`)
};

const hu_booking_booking = /** @type {(inputs: Booking_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalás…`)
};

/**
* | output |
* | --- |
* | "Booking…" |
*
* @param {Booking_BookingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_booking = /** @type {((inputs?: Booking_BookingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_BookingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_booking(inputs)
	if (locale === "de") return de_booking_booking(inputs)
	if (locale === "zh") return zh_booking_booking(inputs)
	if (locale === "ar") return ar_booking_booking(inputs)
	if (locale === "fr") return fr_booking_booking(inputs)
	if (locale === "vi") return vi_booking_booking(inputs)
	if (locale === "sw") return sw_booking_booking(inputs)
	if (locale === "th") return th_booking_booking(inputs)
	if (locale === "bs") return bs_booking_booking(inputs)
	if (locale === "ja") return ja_booking_booking(inputs)
	if (locale === "ko") return ko_booking_booking(inputs)
	if (locale === "pt") return pt_booking_booking(inputs)
	if (locale === "it") return it_booking_booking(inputs)
	if (locale === "sv") return sv_booking_booking(inputs)
	if (locale === "nl") return nl_booking_booking(inputs)
	if (locale === "da") return da_booking_booking(inputs)
	if (locale === "nb") return nb_booking_booking(inputs)
	if (locale === "fi") return fi_booking_booking(inputs)
	if (locale === "pl") return pl_booking_booking(inputs)
	if (locale === "ru") return ru_booking_booking(inputs)
	if (locale === "tr") return tr_booking_booking(inputs)
	if (locale === "hi") return hi_booking_booking(inputs)
	if (locale === "id") return id_booking_booking(inputs)
	if (locale === "ms") return ms_booking_booking(inputs)
	if (locale === "cs") return cs_booking_booking(inputs)
	if (locale === "el") return el_booking_booking(inputs)
	if (locale === "he") return he_booking_booking(inputs)
	if (locale === "af") return af_booking_booking(inputs)
	if (locale === "hu") return hu_booking_booking(inputs)
	return en_booking_booking(inputs)
});